var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 4C13.5 3.73478 13.3946 3.48043 13.2071 3.29289C13.0196 3.10536 12.7652 3 12.5 3H10.5L9 1H5L3.5 3H1.5C1.23478 3 0.98043 3.10536 0.792893 3.29289C0.605357 3.48043 0.5 3.73478 0.5 4V10C0.5 10.2652 0.605357 10.5196 0.792893 10.7071C0.98043 10.8946 1.23478 11 1.5 11H12.5C12.7652 11 13.0196 10.8946 13.2071 10.7071C13.3946 10.5196 13.5 10.2652 13.5 10V4Z",
    stroke: "#0175F0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.75C8.24264 8.75 9.25 7.74264 9.25 6.5C9.25 5.25736 8.24264 4.25 7 4.25C5.75736 4.25 4.75 5.25736 4.75 6.5C4.75 7.74264 5.75736 8.75 7 8.75Z",
    stroke: "#0175F0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImageIcon);
export default __webpack_public_path__ + "static/media/ProfileImageIcon.31aa4e3a008c38e7a1b730efcec2e588.svg";
export { ForwardRef as ReactComponent };